import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import { DriverStatusCssClasses } from "../DriversUIHelpers";
import { useDriversUIContext } from "../DriversUIContext";

const selectedDrivers = (entities, ids) => {
  const _drivers = [];
  ids.forEach((id) => {
    const driver = entities.find((el) => el.id === id);
    if (driver) {
      _drivers.push(driver);
    }
  });
  return _drivers;
};

export function DriversFetchDialog({ show, onHide }) {
  // Drivers UI Context
  const driversUIContext = useDriversUIContext();
  const driversUIProps = useMemo(() => {
    return {
      ids: driversUIContext.ids,
    };
  }, [driversUIContext]);

  // Drivers Redux state
  const { drivers } = useSelector(
    (state) => ({
      drivers: selectedDrivers(
        state.drivers.entities,
        driversUIProps.ids
      ),
    }),
    shallowEqual
  );

  // if drivers weren't selected we should close modal
  useEffect(() => {
    if (!driversUIProps.ids || driversUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driversUIProps.ids]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Fetch selected elements
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="timeline timeline-5 mt-3">
          {drivers.map((driver) => (
            <div className="timeline-item align-items-start" key={`id${driver.id}`}>
              <div className="timeline-label font-weight-bolder text-dark-75 font-size-lg text-right pr-3" />
              <div className="timeline-badge">
                <i
                  className={`fa fa-genderless text-${
                    DriverStatusCssClasses[driver.status]
                  } icon-xxl`}
                />
              </div>
              <div className="timeline-content text-dark-50 mr-5">
                <span
                    className={`label label-lg label-light-${
                      DriverStatusCssClasses[driver.status]
                    } label-inline`}
                  >
                    ID: {driver.id}
                </span>
                <span className="ml-3">{driver.lname}, {driver.fname}</span>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-primary btn-elevate"
          >
            Ok
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
